import { createSlice } from '@reduxjs/toolkit';
import { SESSION_STORAGE_KEYS } from '../../constants/sessionStorageKeys';
import { SLICES } from '../../constants/slices';

const initialState = {
  petDetailsList: JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.PET_DETAILS)) || [],
  fullPolicyNumber: null
};

const petDetailsSlice = createSlice({
  name: SLICES.PET_DETAILS,
  initialState,
  reducers: {
    setPetDetails: (state, action) => {
      state.petDetailsList = action.payload;
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PET_DETAILS, JSON.stringify(state.petDetailsList));
    },
    clearPetDetails: (state) => {
      state.petDetailsList = [];
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PET_DETAILS, JSON.stringify([]));
    },
    setFullPolicyNumber: (state, action) => {
      state.fullPolicyNumber = action.payload;
    },
    clearFullPolicyNumber: (state) => {
      state.fullPolicyNumber = null;
    }
  }
});

export const { setPetDetails, clearPetDetails, setFullPolicyNumber, clearFullPolicyNumber } = petDetailsSlice.actions;

export default petDetailsSlice.reducer;
